import * as Headless from '@headlessui/react'
import clsx from 'clsx'

import { Text } from './text'

const sizes = {
  xs: 'sm:max-w-xs',
  sm: 'sm:max-w-sm',
  md: 'sm:max-w-md',
  lg: 'sm:max-w-lg',
  xl: 'sm:max-w-xl',
  '2xl': 'sm:max-w-2xl',
  '3xl': 'sm:max-w-3xl',
  '4xl': 'sm:max-w-4xl',
  '5xl': 'sm:max-w-5xl',
}

export function Dialog({ open = true, onClose = () => {}, size = 'lg', className, children, ...props }) {
  return (
    <Headless.Dialog open={open} onClose={onClose} {...props}>
      <Headless.DialogBackdrop className="fixed inset-0 z-50 bg-zinc-950/30 backdrop-blur-sm" />
      <div className="fixed inset-0 z-50 w-screen overflow-y-auto px-3 py-6 sm:px-6 sm:py-10">
        <div className="flex min-h-full items-end justify-center sm:items-center">
          <Headless.DialogPanel
            className={clsx(
              'w-full min-w-0 rounded-2xl bg-white p-6 shadow-2xl ring-1 ring-zinc-950/10 sm:p-8',
              sizes[size],
              className
            )}
          >
            {children}
          </Headless.DialogPanel>
        </div>
      </div>
    </Headless.Dialog>
  )
}

export function DialogTitle({ className, ...props }) {
  return <Headless.DialogTitle {...props} className={clsx('text-lg font-semibold text-zinc-950', className)} />
}

export function DialogDescription({ className, ...props }) {
  return <Headless.Description as={Text} {...props} className={clsx('mt-2', className)} />
}

export function DialogBody({ className, ...props }) {
  return <div {...props} className={clsx('mt-6', className)} />
}

export function DialogActions({ className, ...props }) {
  return <div {...props} className={clsx('mt-8 flex flex-col-reverse items-stretch justify-end gap-3 sm:flex-row sm:items-center', className)} />
}
